/* Nautilus CRO - 2026-06-10 - Azul colorway swatch UI */
/* Azul has a single Shopify variant ("Default Title") so per-variant featured
   images can't drive the cart thumbnail like they do on Pula. Instead we pass
   the colorway-specific image URL as properties[_image] on add-to-cart; the
   cart snippet renders that as the thumbnail. properties[Color] is also sent
   (human-readable, shown in cart + order) so the merchant knows which color
   to ship. */
(function () {
  'use strict';

  var COLOR_PROPERTY_NAME = 'properties[Color]';
  var IMAGE_PROPERTY_NAME = 'properties[_image]';
  var IMAGE_URLS = {
    tide: 'https://cdn.shopify.com/s/files/1/1000/1930/6831/files/Azul1.png?v=1777637124',
    noir: 'https://cdn.shopify.com/s/files/1/1000/1930/6831/files/Azul1b.png?v=1777637124',
    wild: 'https://cdn.shopify.com/s/files/1/1000/1930/6831/files/Azul1c.png?v=1777637124'
  };
  // Map: lowercase color name → variant ID string (if Shopify has color variants)
  var variantIdMap = {};
  var pendingColor = null;

  function loadVariantMap() {
    fetch('/products/azul.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        product.variants.forEach(function (v) {
          if (v.option1) variantIdMap[v.option1.toLowerCase()] = String(v.id);
        });
        if (pendingColor) {
          applyToForm(pendingColor);
          pendingColor = null;
        }
      })
      .catch(function () {});
  }

  function findForm() {
    return (
      document.querySelector('[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form-component form') ||
      document.querySelector('form[action*="cart"]')
    );
  }

  function ensureHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.parentNode) {
        idInput.parentNode.insertBefore(input, idInput);
      } else {
        form.appendChild(input);
      }
    }
    input.value = value;
  }

  function writeVariantId(form, colorName) {
    var variantId = variantIdMap[colorName.toLowerCase()];
    if (!variantId) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
  }

  function applyToForm(colorName) {
    var form = findForm();
    if (!form) {
      pendingColor = colorName;
      return;
    }
    ensureHiddenInput(form, COLOR_PROPERTY_NAME, colorName);
    var imgUrl = IMAGE_URLS[colorName.toLowerCase()];
    if (imgUrl) ensureHiddenInput(form, IMAGE_PROPERTY_NAME, imgUrl);
    writeVariantId(form, colorName);
  }

  function resetSlideshow(gallery) {
    var slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;
    var scroller = slideshow.querySelector('[ref="scroller"]') ||
                   slideshow.querySelector('slideshow-slides');
    if (scroller) {
      scroller.scrollLeft = 0;
      scroller.scrollTop = 0;
    }
    if (typeof slideshow.select === 'function') {
      try { slideshow.select(0, undefined, { animate: false }); } catch (e) {}
    }
  }

  function applyColorway(colorway) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var slides = Array.from(gallery.querySelectorAll('slideshow-slide[data-azul-colorway]'));
    slides.forEach(function (s) {
      if (s.dataset.azulColorway === colorway) {
        s.removeAttribute('hidden');
        s.style.display = '';
      } else {
        s.setAttribute('hidden', '');
        s.style.display = 'none';
      }
    });

    var matching = slides.filter(function (s) { return s.dataset.azulColorway === colorway; });
    if (matching.length > 1) {
      var parent = matching[0].parentNode;
      var sorted = matching.slice().sort(function (a, b) {
        return parseInt(a.dataset.azulOrder || '99', 10) - parseInt(b.dataset.azulOrder || '99', 10);
      });
      sorted.forEach(function (s) { parent.appendChild(s); });
    }

    var gridItems = Array.from(gallery.querySelectorAll('.media-gallery__grid li[data-azul-colorway]'));
    gridItems.forEach(function (li) {
      li.style.display = li.dataset.azulColorway === colorway ? '' : 'none';
    });

    var matchingGrid = gridItems.filter(function (li) { return li.dataset.azulColorway === colorway; });
    if (matchingGrid.length > 1) {
      var gridParent = matchingGrid[0].parentNode;
      var sortedGrid = matchingGrid.slice().sort(function (a, b) {
        return parseInt(a.dataset.azulOrder || '99', 10) - parseInt(b.dataset.azulOrder || '99', 10);
      });
      sortedGrid.forEach(function (li) { gridParent.appendChild(li); });
    }

    resetSlideshow(gallery);
    requestAnimationFrame(function () { resetSlideshow(gallery); });
  }

  function syncActive(swatches, colorway, container) {
    swatches.forEach(function (s) {
      s.classList.toggle('nc-azul-swatch--active', s.dataset.color.toLowerCase() === colorway);
    });
    var label = container.querySelector('.nc-azul-colorway-name');
    if (label) {
      var active = swatches.find(function (s) { return s.dataset.color.toLowerCase() === colorway; });
      label.textContent = active ? active.dataset.color : colorway;
    }
  }

  function init() {
    loadVariantMap();

    var container = document.querySelector('[data-azul-swatches]');
    if (!container) return;

    var swatches = Array.from(container.querySelectorAll('.nc-azul-swatch'));
    if (!swatches.length) return;

    // Fall back to the first swatch (Tide) whenever data-initial-color is empty,
    // missing, or a stale value like "Default Title" that no swatch matches.
    // Without this guard, the gallery hides every slide and the label renders
    // whatever Liquid passed in (e.g. "Default Title").
    var requested = (container.dataset.initialColor || '').toLowerCase();
    var matchedSwatch = swatches.find(function (s) {
      return s.dataset.color.toLowerCase() === requested;
    });
    var activeSwatch = matchedSwatch || swatches[0];
    var initialColor = activeSwatch.dataset.color.toLowerCase();
    var initialDisplayName = activeSwatch.dataset.color;

    applyColorway(initialColor);
    syncActive(swatches, initialColor, container);
    applyToForm(initialDisplayName);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var colorway = this.dataset.color.toLowerCase();
        syncActive(swatches, colorway, container);
        applyColorway(colorway);
        applyToForm(this.dataset.color);
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
